<template>
  <ion-content id="app" class="ion-padding">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-sm="6" offset-sm="3">
          <h1 class="ion-padding">Box oder Tab bearbeiten</h1>
          <BoxFields modus="edit" :id="id"/>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</template>

<script>
  import BoxFields from "../../components/box/BoxFields.vue";
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "BoxEdit",
    components: {BoxFields},
    data(){
      return {
        id: this.$route.params.id
      }
    },
    methods: {
      ...mapActions([ "getBoxes" ]),
    },
    computed: mapGetters(["allBoxes"]),
    created() {

    }
  };
</script>

<style scoped>
  h1 {
    color: #B6B6B6;
  }

</style>
